/**
 * FNV-1a. Used wherever the client has to pick something stable from a string
 *, an avatar tint, a placeholder gradient, so the same handle lands on the
 * same result on every device and across every reload.
 */
export function hash(input: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}
